<mat-grid-list cols='5' gutterSize='10' rowHeight="240px" class="md-layout md-alignment-top-center">
    <mat-grid-tile colspan='1' rowspan='3'>
        <tl-spot-buy-sell-card></tl-spot-buy-sell-card>
    </mat-grid-tile>
    <mat-grid-tile colspan='1' rowspan='2'>
        <tl-spot-orderbook-card></tl-spot-orderbook-card>
    </mat-grid-tile>
    <mat-grid-tile colspan='2' rowspan='2'>
        <tl-spot-chart-card></tl-spot-chart-card>
    </mat-grid-tile>
    <mat-grid-tile colspan='1' rowspan='2'>
        <tl-spot-history-card></tl-spot-history-card>
    </mat-grid-tile>
    <mat-grid-tile colspan='4' rowspan='1'>
        <tl-spot-bottom-card></tl-spot-bottom-card>
    </mat-grid-tile>
</mat-grid-list>